<template>
    <modal class="support" name="support" height="auto">
        <form method="post" action="" @submit.prevent="submit()">
            <div class="modal-header">
                <slot name="header">
                    <h4>{{ t('Report a note')+'/'+t('Ask a question') }}</h4>
                </slot>
            </div>

            <div class="modal-body">
                <slot name="body">

                    <select v-model="type" @change="change(type)" class="form-control">
                        <option value="0" disabled>-{{ t('Select') }}-</option>
                        <option v-for="(option, key) in options" v-bind:value="option">{{ t(option.name) }}</option>
                    </select>

                    <blockquote v-if="type">
                        {{ type.description }}
                    </blockquote>

                    <div v-if="type">
                        <textarea maxlength="2500" style="min-height:150px;" v-model="description" class="form-control" :placeholder="t('Describe your application')"></textarea>

                        <br />

                        <label>
                            <input type="checkbox" checked="checked" /> {{ t('Attach the browser information') }}
                        </label>

                    </div>

                    <div class="alert-dismissable alert-danger text-center" v-show="error">
                        {{ error }}
                    </div>

                    <div class="alert-dismissable alert-success text-center" v-show="sent">
                        {{ t('The application has been sent') }}
                    </div>


                </slot>
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    <button type="button" class="pull-left btn btn-cancel btn-sm" @click="close">{{ t('Cancel') }}</button>

                    <input type="submit" class="btn btn-confirm btn-sm" :value="t('Send')" v-show="!sending && !sent" :disabled="!type || !description">
                    <span v-show="sending">{{ t('Sending') }}...</span>
                </slot>
            </div>
        </form>
    </modal>
</template>

<script>
    import Vue from 'vue';

    export default
    {
        data()
        {
            return {
                type: 0,
                description: null,
                error: false,
                sending: false,
                sent: false,
                initialized: {},
                options: {
                    error: {
                        name: 'Error',
                        description: this.$translate.text('Interface malfunctions or data incorrectness (e.g. no products, no offers, incorrect connections)'),
                        text: null,
                    },
                    extension: {
                        name: 'Extension',
                        description: this.$translate.text('Proposals for new application functionalities'),
                        text: null,
                    },
                    question: {
                        name: 'Question',
                        description: this.$translate.text('Any remaining doubts about the operation of the system'),
                        text: null,
                    },
                    report: {
                        name: 'Report',
                        description: this.$translate.text('New report'),
                        text:
                            'Typ raportu (excell/dashboard):\n' +
                            '\n' +
                            'Częstotliwość generowania (dla excell: codziennie, co tydzień, co miesiąc):\n' +
                            '\n' +
                            'Opis raportu (jakie dane ma generować raport):\n' +
                            '\n' +
                            'Lista pól (kolumn) w raporcie :\n'
                    },
                }
            };
        },
        mounted()
        {
        },
        methods:
            {
                change(type)
                {
                    this.description = type.text
                },
                optionDescription(key) {
                    return this.options[key].description;
                },
                submit() {
                    const v = this;

                    this.sending = true;

                    const data = {
                        type: this.type.name,
                        description: this.description,
                        browser: [],
                    }

                    this.$http.post('support/apply', data).then(response => {
                        this.sent = true;
                        this.sending = false;

                        setTimeout(() => {
                            this.$modal.hide(this.modalName);
                        }, 1500)

                    }, (response) => {
                        v.error = response.body.message
                        this.sending = false;
                    })
                },
                close()
                {
                    this.type = 0;
                    this.description = null;
                    this.error = false;
                    this.sending = false;
                    this.sent = false;

                    this.$modal.hide(this.modalName);
                },
                browserInformation()
                {
                    {

                    };
                    {{ t('Report a note')+'/'+t('Ask a question') }}
                    return [];
                }
        },
        created() {
            this.modalName = 'support';
        }

    }

</script>

<style lang="sass">

    .support
    {
        blockquote {
            margin:5px 0px 10px 0px;
            font-size:13px;
            font-style:italic;
            padding:5px;
            color:gray;
        }

        .alert-dismissable {
            margin-top:10px;
        }
    }
    .v--modal{
    height:600px;
    }

</style>


// WEBPACK FOOTER //
// index.vue?01ee5952